export default __webpack_public_path__ + "static/media/biofit-builder-series-WW.eeb53f85.png";